import React from 'react';
import { useCreateMembershipPerk } from 'api/membership-perks';
import MembershipPerkForm from './membership-perk-form';
import { useHistory } from 'react-router';
import { useQueryClient } from 'react-query';

function MembershipPerkCreate() {
  const history = useHistory();
  const queryClient = useQueryClient();
  const { mutate: createMembershipPerk, isLoading: isSaving } = useCreateMembershipPerk({
    onSuccess: async () => {
      await queryClient.invalidateQueries('getMembershipPerks');
      history.push('/membership-perks');
    },
  });

  async function onSave(values) {
    await createMembershipPerk(values);
  }

  return <MembershipPerkForm onSave={onSave} isSaving={isSaving} />;
}

export default MembershipPerkCreate;
